import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import RadioField from "../../../../common/components/FormFields/RadioField";
import InputField from "../../../../common/components/FormFields/InputField";
import GcsCalculatorModal from "./GcsCalculatorModal";
import CommonButton from "../../../../common/components/Buttons/CommonButton";

const MewsRadio = [
  {
    id: "0",
    value: "0",
    label: "A",
  },
  {
    id: "1",
    value: "1",
    label: "V",
  },
  {
    id: "2",
    value: "2",
    label: "P",
  },
  {
    id: "3",
    value: "3",
    label: "U",
  },
];

const ClinicalFindings = (props) => {
  const [openModal, setOpenModal] = React.useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const { control, setValue, watch } = useFormContext();

  let Avpu = watch("mewsRadio");

  useEffect(() => {
    setValue("gcsScore", props.gcsScore, {
      shouldValidate: true,
    });

    setValue("mewsScore", props.mewsScore, {
      shouldValidate: true,
    });
  }, [props.gcsScore, props.mewsScore]);

  ///////////////
  const [temp, pulse, rr] = watch(["temp", "pulse", "respiration"]);

  // to remove slash while considering b/p
  let bpStr = watch("bp");
  let arr = !!bpStr && bpStr?.split("/");
  let bp = arr && arr[0];
  // calculation for mews score calculation
  const convertToCelsius = (fahrenheit) => {
    return ((fahrenheit - 32) * 5) / 9;
  };
  function SystolicBloodPressure(sbp) {
    if (sbp >= 200) {
      return 2;
    } else if (sbp >= 101 && sbp <= 199) {
      return 0;
    } else if (sbp >= 81 && sbp <= 100) {
      return 1;
    } else if (sbp >= 71 && sbp <= 80) {
      return 2;
    } else if (sbp <= 70) {
      return 3;
    }
    return 0; // Default return value
  }
  function PulseCalculation(pulse) {
    if (pulse <= 40) {
      return 2;
    } else if (pulse >= 41 && pulse <= 50) {
      return 1;
    } else if (pulse >= 51 && pulse <= 100) {
      return 0;
    } else if (pulse >= 101 && pulse <= 110) {
      return 1;
    } else if (pulse >= 111 && pulse <= 129) {
      return 2;
    } else if (pulse >= 130) {
      return 3;
    }
    return 0; // Default return value
  }
  function RespiratoryRate(bpm) {
    if (bpm <= 8) {
      return 2;
    } else if (bpm >= 9 && bpm <= 14) {
      return 0;
    } else if (bpm >= 15 && bpm <= 20) {
      return 1;
    } else if (bpm >= 21 && bpm <= 29) {
      return 2;
    } else if (bpm >= 30) {
      return 3;
    }
    return 0; // Default return value
  }
  function Temperature(tempCelsius) {
    if (tempCelsius < 35) return 2;
    else if (tempCelsius >= 35 && tempCelsius <= 38.4) return 0;
    else if (tempCelsius > 38.5) return 2;
    return 0;
  }

  const calculateMews = (bp, temp, pulse, rr, Avpu) => {
    if (
      Number(bp) > 0 &&
      Number(temp) > 0 &&
      Number(pulse) > 0 &&
      Number(rr) > 0 &&
      Avpu !== null
    ) {
      const bpValue = SystolicBloodPressure(bp);
      const pulseValue = PulseCalculation(pulse);
      const tempCelsius = convertToCelsius(temp)
      const tempValue = Temperature(tempCelsius);
      const rrValue = RespiratoryRate(rr);

      return bpValue + pulseValue + tempValue + rrValue + Number(Avpu);
    }
    return 0; // Default return value if inputs are invalid
  };

  // let finalMews;
  // useEffect(() => {
  //   finalMews = calculateMews(bp, temp, pulse, rr);

  //   let mewsWithAvpu = Number(finalMews) + Number(Avpu);

  //   if (mewsWithAvpu >= 5) {
  //     setValue("mewsAlert", "Please Call Doctor For Consultation");
  //   } else if (mewsWithAvpu < 5) {
  //     setValue("mewsAlert", "No Need to Call Doctor For Consultation");
  //   }

  //   props.setMewsScore(Number(mewsWithAvpu));
  // }, [bp, temp, pulse, rr, Avpu]);
    useEffect(() => {
      const finalMews = calculateMews(bp, temp, pulse, rr, Avpu);
      props.setMewsScore(finalMews);
  
    
    }, [bp, temp, pulse, rr, Avpu]);

  return (
    <div>
      <div className="grid lg:grid-cols-5 md:grid-cols-4 gap-3">
        {/* Temp */}
        <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1  text-sm py-1">
          <span className="  w-28">Temp</span>
          <div className="flex space-x-2 items-center">
            <span>:</span>
            <span className="text-gray-700 font-normal w-24">
              <InputField
                type="number"
                name="temp"
                variant="outlined"
                label="°F"
                placeholder="°F"
                control={control}
                disabled={false}
                inputProps={{ maxLength: 50 }}
              />
            </span>
          </div>
        </div>
        {/* Pulse rate */}
        <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1  text-sm py-1">
          <span className="  w-28">Pulse Rate</span>
          <div className="flex space-x-2 items-center">
            <span>:</span>
            <span className="text-gray-700 font-normal w-24">
              <InputField
                type="number"
                name="pulse"
                variant="outlined"
                label="Pulse Rate/min"
                placeholder="Pulse Rate/min"
                control={control}
                disabled={false}
                inputProps={{ maxLength: 50 }}
              />
            </span>
          </div>
        </div>
        {/* B/P */}
        <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1  text-sm py-1">
          <span className="  w-28">B/P</span>
          <div className="flex space-x-2 items-center">
            <span>:</span>
            <span className="text-gray-700 font-normal w-24">
              <InputField
                name="bp"
                variant="outlined"
                label="mmHg"
                placeholder="mmHg"
                control={control}
                disabled={false}
                inputProps={{ maxLength: 50 }}
              />
            </span>
          </div>
        </div>
        {/* SpO2 */}
        <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1  text-sm py-1">
          <span className="  w-28">SpO2</span>
          <div className="flex space-x-2 items-center">
            <span>:</span>
            <span className="text-gray-700 font-normal w-24">
              <InputField
                type="number"
                name="spo2"
                variant="outlined"
                label="%"
                placeholder="%"
                control={control}
                disabled={false}
                inputProps={{ maxLength: 50 }}
              />
            </span>
          </div>
        </div>

        {/* Respiration */}
        <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1  text-sm py-1">
          <span className="  w-28">Respiration</span>
          <div className="flex space-x-2 items-center">
            <span>:</span>
            <span className="text-gray-700 font-normal w-24">
              <InputField
                type="number"
                name="respiration"
                variant="outlined"
                label=" Respiration/min"
                placeholder=" Respiration/min"
                control={control}
                disabled={false}
                inputProps={{ maxLength: 50 }}
              />
            </span>
          </div>
        </div>
        {/* BSL */}
        <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1  text-sm py-1">
          <span className="  w-28">BSL</span>
          <div className="flex space-x-2 items-center">
            <span>:</span>
            <span className="text-gray-700 font-normal w-24">
              <InputField
                type="number"
                name="bsl"
                variant="outlined"
                control={control}
                disabled={false}
                inputProps={{ maxLength: 50 }}
              />
            </span>
          </div>
        </div>

        {/* pews */}
        {props.patientData?.Age > 14 ? null : (
          <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1  text-sm py-1">
            <span className="  w-28">Pews</span>
            <div className="flex space-x-2 items-center">
              <span>:</span>
              <span className="text-gray-700 font-normal w-24">
                <InputField
                  type="number"
                  name="pews"
                  variant="outlined"
                  control={control}
                  disabled={false}
                  inputProps={{ maxLength: 50 }}
                />
              </span>
            </div>
          </div>
        )}

        {/* gcs */}
        <div className="flex items-center gap-2 w-full col-span-2 xl:col-span-1  text-sm py-1">
          <span className="  w-28">GCS</span>
          <div className="flex space-x-2 items-center">
            <span>:</span>
            <span className="text-gray-700 font-normal w-24">
              <InputField
                type="number"
                name="gcsScore"
                variant="outlined"
                control={control}
                disabled={true}
                inputProps={{ maxLength: 50 }}
              />
            </span>
            <span className="text-gray-700 font-normal w-24">
              <CommonButton
                label="Calc"
                type="button"
                onClick={handleOpenModal}
                className="bg-customBlue text-white"
              />
            </span>
          </div>
        </div>
        {/* mews */}
        <div className="flex items-center gap-2 w-full md:col-span-4 lg:col-span-2   text-sm py-1">
          <span className="  w-28">Mews *</span>
          <div className="flex  items-center">
            <span>:</span>
            <span className="w-56">
              <RadioField
                label=""
                name="mewsRadio"
                control={control}
                dataArray={MewsRadio}
              />
            </span>
            <span className="text-gray-700 font-normal  w-24">
              <InputField
                type="number"
                name="mewsScore"
                variant="outlined"
                // error={errors.representativeAddress}
                control={control}
                disabled={true}
                inputProps={{ maxLength: 50 }}
              />
            </span>
          </div>
        </div>
      </div>
      <div className="grid lg:grid-cols-8 md:grid-cols-4 items-center">
        <div className="col-span-3 flex gap-2 items-center">
          {props.mewsScore !== undefined && props.mewsScore > 0 ? (
            props.mewsScore >= 5 ? (
              <>
                <p> Alert :</p>
                <p className="text-red-600">
                  Please Call Doctor For Consultation
                </p>
              </>
            ) : (
              <>
                <p> Alert :</p>
                <p className="text-green-600">
                  No Need to Call Doctor For Consultation
                </p>
              </>
            )
          ) : null}
        </div>
      </div>

      {/* Gcs Calculator Modal */}
      {openModal ? (
        <GcsCalculatorModal
          open={openModal}
          setOpen={setOpenModal}
          handleOpen={handleOpenModal}
          handleClose={handleCloseModal}
          setGcsScore={props.setGcsScore}
          poulateData={props.poulateData}
          eyeOpeningResponse={props.eyeOpeningResponse}
          setEyeOpeningResponse={props.setEyeOpeningResponse}
          verbalResponse={props.verbalResponse}
          setVerbalResponse={props.setVerbalResponse}
          motorResponse={props.motorResponse}
          setMotorResponse={props.setMotorResponse}
          setGCSData={props.setGCSData}
          GCSData={props.GCSData}
        />
      ) : null}
    </div>
  );
};

export default ClinicalFindings;
